angular
    .module('tradersyard')
    .directive('commentQuery', [
        '$parse',
        '$rootScope',
        'graph-comment-factory',
        '$socket',
        function ($parse, $rootScope, $client, $socket) {
            return {
                link: function ($scope, $element, $attr) {
                    $scope.showComments = false;

                    var entryName = $parse($attr.entry)($scope),
                        entryId = $parse($attr.entryId)($scope),
                        opened = $parse($attr.opened)($scope);

                    var page = 0,
                        client = $client.entry(entryName, entryId);

                    $scope.iterator = $attr.iterator;

                    $scope[$scope.iterator] = [];

                    $scope.limit = 3;
                    $scope.let = 0;
                    $scope.locked = 0;
                    $scope.progress = 0;

                    $scope.queryComment = function (next) {
                        if ($scope.progress === 0 && $scope.locked === 0) {
                            ++page;
                            $scope.progress = 1;

                            client
                                .query({
                                    params: {
                                        limit: $scope.limit,
                                        page: page,
                                        let: $scope.let,
                                    },
                                })
                                .then(function (response) {
                                    if (response.data.state === 0 && response.data.data.length > 0) {
                                        var responseData = response.data.data.filter(function (item) {
                                            return (
                                                $scope[$scope.iterator].filter(function (subitem) {
                                                    return parseInt(subitem.id) === parseInt(item.id);
                                                }).length <= 0
                                            );
                                        });

                                        $scope[$scope.iterator] = responseData
                                            .reverse()
                                            .concat($scope[$scope.iterator]);

                                        $socket.emit(
                                            'join:comment',
                                            response.data.data.map(function (item) {
                                                return item.id;
                                            })
                                        );

                                        if (response.data.data.length !== $scope.limit) $scope.locked = 1;

                                        $scope.progress = 0;

                                        if (next) next();
                                    } else {
                                        $scope.locked = 1;
                                        $scope.progress = 0;
                                    }
                                });
                        }
                    };

                    if ($attr.touch) {
                        $scope.$on('touch:' + $attr.touch, function () {
                            $scope.showComments = !$scope.showComments;
                            if (page <= 0) {
                                $scope.queryComment();
                            }

                            var phase = $scope.$$phase;
                            if (phase == '$apply' || phase == '$digest') {
                                //
                            } else {
                                $scope.$apply();
                            }
                        });
                    }

                    if (!$attr.touch || opened === true) {
                        $scope.showComments = true;
                        $scope.queryComment();
                    }

                    $socket.on('comment:create', function (data) {
                        setTimeout(function () {
                            if (data.place.name === entryName && parseInt(data.place.id) === parseInt(entryId)) {
                                var allowedToAdd =
                                    $scope[$scope.iterator].filter(function (item) {
                                        return parseInt(data.node.id) === parseInt(item.id);
                                    }).length <= 0;

                                if (allowedToAdd) {
                                    ++$scope.let;
                                    $scope[$scope.iterator].push(data.node);
                                    var phase = $scope.$$phase;
                                    if (phase == '$apply' || phase == '$digest') {
                                        //
                                    } else {
                                        $scope.$apply();
                                    }
                                }
                            }
                        });
                    });
                },
            };
        },
    ])
    .factory('commentFormFactory', [
        function () {
            var container = {};

            var template = {
                id: 0,
                content: '',
                photos: [],
                videos: [],
                documents: [],
                links: [],
                new: {
                    photos: [],
                    videos: [],
                    documents: [],
                    links: [],
                },
                trash: {
                    photos: [],
                    videos: [],
                    documents: [],
                    links: [],
                },
                progress: {
                    photos: [],
                    videos: [],
                    documents: [],
                    links: [],
                },
                processing: 0,
            };

            return {
                append: function (data, id) {
                    container[id] = angular.copy(angular.isObject(data) ? data : {});

                    container[id] = angular.extend(angular.copy(template), container[id]);

                    return container[id];
                },
            };
        },
    ])
    .directive('commentNode', [
        '$parse',
        'graph-comment-factory',
        '$compile',
        function ($parse, $client, $compile) {
            return {
                scope: false,
                priority: -5,
                link: function ($scope, $element, $attr) {
                    $scope.mode = 'read';

                    $scope.commentDelete = function (node) {
                        $client
                            .entry()
                            .delete(node.id)
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    $element[0].outerHTML = '';
                                    $compile($element.contents())($scope);

                                    $scope.$parent.comments.forEach(function (item, index) {
                                        if (Number(item.id) === Number(node.id)) {
                                            $scope.$parent.comments.splice(index, 1);
                                        }
                                    });
                                }
                            });
                    };
                },
            };
        },
    ])
    .directive('commentForm', [
        '$parse',
        'commentFormFactory',
        'graph-comment-factory',
        '$rootScope',
        '$flex.array',
        function ($parse, $factory, $client, $rootScope, $array) {
            return {
                scope: true,
                priority: -5,
                link: function ($scope, $element, $attr) {
                    $scope.client = $client.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope));

                    $scope.formComment = $factory.append(
                        $parse($attr.commentData)($scope),
                        $parse($attr.commentId)($scope)
                    );

                    var formlock = 0;

                    $scope.attach = {
                        photo: function (id) {
                            $scope.attach.trigger(id, 'photo');
                        },
                        video: function (id) {
                            $scope.attach.trigger(id, 'video');
                        },
                        document: function (id) {
                            $scope.attach.trigger(id, 'document');
                        },
                        trigger: function (id, type) {
                            document.getElementById('comment-' + id + '-' + type + '-input').click();
                        },
                    };

                    $scope.submit = function (node) {
                        if (formlock === 1) {
                            return;
                        }

                        formlock = 1;
                        if (parseInt(node.id) === 0) {
                            $scope.formComment = $factory.append(undefined, 0);

                            $scope.client.create(node).then(function (response) {
                                formlock = 0;
                                if (response.data.state === 0) {
                                    var scopeData = $parse($attr.pool)($scope);

                                    var allowedToAdd =
                                        scopeData.filter(function (item) {
                                            return parseInt(response.data.data.id) === parseInt(item.id);
                                        }).length <= 0;

                                    if (allowedToAdd) {
                                        scopeData.push(angular.copy(response.data.data));
                                    }

                                    $scope.formComment = $factory.append(undefined, 0);
                                }
                            });
                        } else {
                            $scope.client.update(node.id, node).then(function (response) {
                                formlock = 0;
                                if (response.data.state === 0) {
                                    angular.forEach($parse($attr.pool)($scope), function (iterator) {
                                        if (iterator.id === node.id) angular.extend(iterator, node);
                                    });

                                    $scope.formComment = $factory.append(node, node.id);

                                    if ($attr.after) {
                                        $parse($attr.after)($scope.$parent);

                                        var phase = $scope.$parent.$$phase;

                                        if (phase === '$apply' || phase === '$digest') {
                                            //
                                        } else {
                                            $scope.$parent.$apply();
                                        }
                                    }
                                }
                            });
                        }
                    };

                    $scope.onKeyUpContent = function ($event) {
                        if ($event.keyCode === 13 && $event.shiftKey !== true && $event.ctrlKey !== true) {
                            $event.preventDefault();
                            $scope.fn.submit($scope.formComment);
                        }
                    };

                    $scope.fn = {
                        submit: function (node) {
                            if ($scope.formComment.processing > 0) return;

                            if (formlock === 1) {
                                return;
                            }

                            formlock = 1;

                            var data = angular.copy(node);

                            angular.forEach(['photos', 'videos', 'documents', 'links', 'groups'], function (space) {
                                data[space] = $scope.fn.query(data, space);
                            });

                            if (node.id === undefined || parseInt(node.id) === 0) {
                                $scope.formComment = $factory.append(undefined, 0);

                                $scope.client
                                    .create(data)
                                    .then(function (response) {
                                        formlock = 0;
                                        if (response.data.state === 0) {
                                            var scopeData = $parse($attr.pool)($scope);

                                            var allowedToAdd =
                                                scopeData.filter(function (item) {
                                                    return parseInt(response.data.data.id) === parseInt(item.id);
                                                }).length <= 0;

                                            if (allowedToAdd) {
                                                scopeData.push(angular.copy(response.data.data));
                                            }

                                            $scope.formComment = $factory.append(undefined, 0);
                                        }
                                    })
                                    .then(function () {
                                        // IMPORTANT! This is necessary for processing Boosts Engagements for Social Advertising
                                        //  We are sending $element to see if it's contained in the parent component of a boosted post.
                                        $rootScope.$broadcast('boosts:engagement', {
                                            target: $element,
                                        });
                                    });
                            } else {
                                $scope.client.update(node.id, data).then(function (response) {
                                    formlock = 0;
                                    if (response.data.state === 0) {
                                        angular.forEach($parse($attr.pool)($scope), function (iterator) {
                                            if (iterator.id === node.id) angular.extend(iterator, node);
                                        });

                                        $scope.formComment = $factory.append(node, node.id);

                                        if ($attr.after) {
                                            $parse($attr.after)($scope.$parent);

                                            var phase = $scope.$parent.$$phase;

                                            if (phase === '$apply' || phase === '$digest') {
                                                //
                                            } else {
                                                $scope.$parent.$apply();
                                            }
                                        }
                                    }
                                });
                            }
                        },
                        error: function (error) {
                            $rootScope.$broadcast('graph-modal-show', {
                                title: 'Error',
                                content: error,
                            });
                        },
                        upload: {
                            photos: function () {
                                $scope.formComment.processing++;
                                var photo = $scope.input.photo;
                                $rootScope.$broadcast('comment.progress.start', $scope.formComment);
                                $scope.formComment.progress.photos.push({
                                    name: photo.name,
                                });

                                $scope.client
                                    .storage($scope.formComment.id)
                                    .upload(
                                        {
                                            name: $scope.input.photo.name,
                                            photo: $scope.input.photo.base,
                                        },
                                        'photos'
                                    )
                                    .then(function (response) {
                                        $scope.formComment.processing--;
                                        $scope.formComment.progress.photos = $array.$splice(
                                            $scope.formComment.progress.photos,
                                            { name: photo.name },
                                            'name'
                                        );
                                        $rootScope.$broadcast('comment.progress.end', $scope.formComment);

                                        if (response.data.state === 0) {
                                            var $photo = response.data.data;

                                            if (!$array.$has($scope.formComment.photos, $photo, 'id')) {
                                                $scope.formComment.new.photos.push($photo);
                                                $scope.formComment.photos.push($photo);
                                            }

                                            $scope.fn.submit($scope.formComment);
                                        } else {
                                            $rootScope.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.photo ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                    });
                            },
                            videos: function () {
                                $scope.formComment.processing++;

                                var fd = new FormData();
                                fd.append('video', $scope.input.video.file);
                                fd.append('name', $scope.input.video.name);

                                var video = $scope.input.video;
                                $rootScope.$broadcast('comment.progress.start', $scope.formComment);
                                $scope.formComment.progress.videos.push({
                                    name: video.name,
                                });

                                $scope.client
                                    .storage($scope.formComment.id)
                                    .upload(fd, 'videos')
                                    .then(function (response) {
                                        $scope.formComment.processing--;
                                        $scope.formComment.progress.videos = $array.$splice(
                                            $scope.formComment.progress.videos,
                                            { name: video.name },
                                            'name'
                                        );
                                        $rootScope.$broadcast('comment.progress.end', $scope.formComment);

                                        if (response.data.state === 0) {
                                            var $video = response.data.data;

                                            if (!$array.$has($scope.formComment.videos, $video, 'id')) {
                                                $scope.formComment.new.videos.push($video);
                                                $scope.formComment.videos.push($video);
                                            }

                                            $scope.fn.submit($scope.formComment);
                                        } else {
                                            $rootScope.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.video ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                    });
                            },
                            documents: function () {
                                $scope.formComment.processing++;
                                var fd = new FormData();
                                fd.append('document', $scope.input.document.file);
                                fd.append('name', $scope.input.document.name);

                                var document = $scope.input.document;
                                $rootScope.$broadcast('comment.progress.start', $scope.formComment);
                                $scope.formComment.progress.documents.push({
                                    name: document.name,
                                });

                                $scope.client
                                    .storage($scope.formComment.id)
                                    .upload(fd, 'documents')
                                    .then(function (response) {
                                        $scope.formComment.processing--;
                                        $scope.formComment.progress.documents = $array.$splice(
                                            $scope.formComment.progress.documents,
                                            { name: document.name },
                                            'name'
                                        );
                                        $rootScope.$broadcast('comment.progress.end', $scope.formComment);

                                        if (response.data.state === 0) {
                                            var $document = response.data.data;

                                            if (!$array.$has($scope.formComment.documents, $document, 'id')) {
                                                $scope.formComment.new.documents.push($document);
                                                $scope.formComment.documents.push($document);
                                            }

                                            $scope.fn.submit($scope.formComment);
                                        } else {
                                            $rootScope.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.document ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                    });
                            },
                            links: linkUpload,
                        },
                        attach: {
                            photos: function () {
                                $scope.formComment.processing++;
                                var photo = $scope.input.photo;
                                $scope.formComment.progress.photos.push({
                                    name: photo.name,
                                });

                                $scope.client
                                    .storage($scope.formComment.id)
                                    .upload(
                                        {
                                            name: $scope.input.photo.name,
                                            photo: $scope.input.photo.base,
                                        },
                                        'photos'
                                    )
                                    .then(function (response) {
                                        $scope.formComment.processing--;
                                        $scope.formComment.progress.photos = $array.$splice(
                                            $scope.formComment.progress.photos,
                                            { name: photo.name },
                                            'name'
                                        );

                                        if (response.data.state === 0) {
                                            var $photo = response.data.data;

                                            if (!$array.$has($scope.formComment.photos, $photo, 'id')) {
                                                $scope.formComment.new.photos.push($photo);
                                                $scope.formComment.photos.push($photo);
                                            }
                                        } else {
                                            $rootScope.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.photo ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                    });
                            },
                            videos: function () {
                                $scope.formComment.processing++;
                                var video = $scope.input.video;
                                $scope.formComment.progress.videos.push({
                                    name: video.name,
                                });

                                $scope.client
                                    .storage($scope.formComment.id)
                                    .upload(
                                        {
                                            name: $scope.input.video.name,
                                            video: $scope.input.video.base,
                                        },
                                        'videos'
                                    )
                                    .then(function (response) {
                                        $scope.formComment.progress.videos = $array.$splice(
                                            $scope.formComment.progress.videos,
                                            { name: video.name },
                                            'name'
                                        );

                                        if (response.data.state === 0) {
                                            var $video = response.data.data;

                                            if (!$array.$has($scope.formComment.videos, $video, 'id')) {
                                                $scope.formComment.new.videos.push($video);
                                                $scope.formComment.videos.push($video);
                                            }
                                        } else {
                                            $rootScope.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.video ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                        $scope.formComment.processing--;
                                    });
                            },
                            documents: function () {
                                $scope.formComment.processing++;
                                var fd = new FormData();
                                fd.append('document', $scope.input.document.file);
                                fd.append('name', $scope.input.document.name);

                                var document = $scope.input.document;
                                $scope.formComment.progress.documents.push({
                                    name: document.name,
                                });

                                $scope.client
                                    .storage($scope.formComment.id)
                                    .upload(fd, 'documents')
                                    .then(function (response) {
                                        $scope.formComment.progress.documents = $array.$splice(
                                            $scope.formComment.progress.documents,
                                            { name: document.name },
                                            'name'
                                        );

                                        if (response.data.state === 0) {
                                            var $document = response.data.data;

                                            if (!$array.$has($scope.formComment.documents, $document, 'id')) {
                                                $scope.formComment.new.documents.push($document);
                                                $scope.formComment.documents.push($document);
                                            }
                                        } else {
                                            $rootScope.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.document ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                        $scope.formComment.processing--;
                                    });
                            },
                            links: function ($event) {
                                var part =
                                    /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)(.*)?(#[\w\-]+)*\/?$/;

                                var clip = $event.originalEvent.clipboardData;

                                var url = clip
                                    ? clip.getData('text/plain')
                                    : angular.element($event.currentTarget).val();

                                if (
                                    part.test(url) &&
                                    !$array.$has($scope.formComment.links, { address: url }, 'address')
                                ) {
                                    $scope.formComment.processing++;

                                    $scope.formComment.progress.links.push({
                                        name: url,
                                    });

                                    $scope.client
                                        .links($scope.formComment.id)
                                        .upload({
                                            link: url,
                                        })
                                        .then(function (response) {
                                            $scope.formComment.progress.links = $array.$splice(
                                                $scope.formComment.progress.links,
                                                { name: url },
                                                'name'
                                            );

                                            if (response.data.state === 0) {
                                                $scope.formComment.links.push(response.data.data);
                                            } else {
                                                $rootScope.$broadcast('graph-modal-show', {
                                                    title: 'Error',
                                                    content:
                                                        response.data.data.link ||
                                                        'The file is too large or the format is incorrect.',
                                                });
                                            }
                                            $scope.formComment.processing--;
                                        });
                                }
                            },
                        },
                        detach: {
                            photos: function (photo) {
                                $scope.formComment.photos = $array.$splice($scope.formComment.photos, photo, 'id');

                                $scope.formComment.new.photos = $array.$splice(
                                    $scope.formComment.new.photos,
                                    photo,
                                    'id'
                                );

                                if ($scope.formComment.id === 0) {
                                    $scope.client.photos($scope.formComment.id).delete(photo.id);
                                } else {
                                    $scope.formComment.trash.photos.push(photo);
                                }
                            },
                            videos: function (video) {
                                $scope.formComment.videos = $array.$splice($scope.formComment.videos, video, 'id');

                                $scope.formComment.new.videos = $array.$splice(
                                    $scope.formComment.new.videos,
                                    video,
                                    'id'
                                );
                                if ($scope.formComment.id === 0) {
                                    $scope.client.videos($scope.formComment.id).delete(video.id);
                                } else {
                                    $scope.formComment.trash.videos.push(video);
                                }
                            },
                            documents: function (document) {
                                $scope.formComment.documents = $array.$splice(
                                    $scope.formComment.documents,
                                    document,
                                    'id'
                                );

                                $scope.formComment.new.documents = $array.$splice(
                                    $scope.formComment.new.documents,
                                    document,
                                    'id'
                                );
                                if ($scope.formComment.id === 0) {
                                    $scope.client.documents($scope.formComment.id).delete(document.id);
                                } else {
                                    $scope.formComment.trash.documents.push(document);
                                }
                            },
                            links: function (link) {
                                if (!link) {
                                    return;
                                }

                                $scope.formComment.links = $array.$splice($scope.formComment.links, link, 'id');

                                $scope.formComment.new.links = $array.$splice($scope.formComment.new.links, link, 'id');
                                if ($scope.formComment.id === 0) {
                                    $scope.client.links($scope.formComment.id).delete(link.id);
                                } else {
                                    $scope.formComment.trash.links.push(link);
                                }
                            },
                        },
                        cancel: function () {
                            if ($scope.formComment.processing > 0) return;

                            for (var type in $scope.formComment.new) {
                                var attachment = $scope.formComment.new[type];

                                for (var i = 0; i < attachment.length; i++) {
                                    var attach = attachment[i];

                                    $scope.fn.detach[type](attach);
                                    $scope.formComment.new[type].splice(i, 1);
                                }
                            }

                            for (type in $scope.formComment.trash) {
                                var trash = $scope.formComment.trash[type];

                                for (var j = 0; j < trash.length; j++) {
                                    var item = trash[j];

                                    $scope.formComment[type].push(item);
                                    $scope.formComment.trash[type].splice(j, 1);
                                }
                            }

                            if ($attr.after) {
                                var phase = $scope.$parent.$$phase;
                                if (phase === '$apply' || phase === '$digest') $scope.$parent.$eval($attr.after);
                                else $scope.$parent.$apply($attr.after);
                            }
                        },
                        query: function (data, key) {
                            var values = [];

                            angular.forEach(data[key], function (item) {
                                values.push(angular.isObject(item) ? item.id : item);
                            });

                            return values;
                        },
                    };

                    function linkUpload($event) {
                        var part = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)(.*)?(#[\w\-]+)*\/?$/;
                        var clip = $event.originalEvent.clipboardData;
                        var url = clip ? clip.getData('text/plain') : angular.element($event.currentTarget).val();

                        if (part.test(url) && !$array.$has($scope.formComment.links, { address: url }, 'address')) {
                            $scope.formComment.processing++;

                            $rootScope.$broadcast('comment.progress.start', $scope.formComment);
                            $scope.formComment.progress.links.push({
                                name: url,
                            });

                            $scope.client
                                .links($scope.formComment.id)
                                .upload({
                                    link: url,
                                })
                                .then(function (response) {
                                    $scope.formComment.progress.links = $array.$splice(
                                        $scope.formComment.progress.links,
                                        { name: url },
                                        'name'
                                    );

                                    $rootScope.$broadcast('comment.progress.end', $scope.formComment);

                                    if (response.data.state === 0) {
                                        $scope.formComment.links.push(response.data.data);
                                    } else {
                                        $rootScope.$broadcast('graph-modal-show', {
                                            title: 'Error',
                                            content:
                                                response.data.data.link ||
                                                'The file is too large or the format is incorrect.',
                                        });
                                    }

                                    $scope.formComment.processing--;
                                });
                        }
                    }
                },
            };
        },
    ]);
